import { makeStyles } from '@material-ui/core/styles';
export const useMyPaymentsStyle = makeStyles(theme => ({
    MyPaymentsWrapper: {
        marginBottom: '60px',
        margin: 'auto',
        paddingLeft: '30px',
        paddingRight: '30px',
        [theme.breakpoints.down('xs')]: {
            padding: '0px',
        },

        '& .myPaymentsContainer': {
            maxWidth: '995px',
            boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
            borderRadius: '10px',
            margin: 'auto',
            background: theme.palette.primary.white,
            padding: '24px 32px 14px',

            [theme.breakpoints.between('sm', 'md')]: {
                maxWidth: '694px',
            },
            [theme.breakpoints.up('xl')]: {
                maxWidth: '1076px',
            },

            [theme.breakpoints.down('xs')]: {
                padding: '19.57px 15px 50px',
                maxWidth: 'calc(344 / 360 * 100vw)',
            },

            '& .payments-header': {
                fontFamily: theme.typography.body3Medium.fontFamily,
                fontStyle: 'normal',
                // fontWeight: 700,
                fontSize: theme.typography.h3.fontSize,
                lineHeight: '33px',
                display: 'block',
                alignItems: 'center',
                textAlign: 'center',
                letterSpacing: '0.25px',
                color: theme.palette.primary.heather,

                minHeight: '120px',
                padding: '24px 32px 0px',
                alignItems: 'flex-start',
                [theme.breakpoints.down('xs')]: {
                    padding: '24px 15px 0px',
                },
                // '@media(max-width: 599px)': {
                //     padding: '24px 10px 0px',
                // },
            },

            '& .payment-loader': {
                '& .payments-content-loading': {
                    '& .payments-retry-loading': {},
                },

                '& .mypayments-loading-animation': {
                    padding: '0px!important',
                    // '@media(max-width: 1019px)': {
                    //     padding: '0px!important',
                    // },
                    [theme.breakpoints.down('md')]: {
                        padding: '0px!important',
                    },
                    [theme.breakpoints.down('xs')]: {
                        padding: '0px!important',
                    },
                    // '@media(max-width: 599px)': {
                    //     padding: '0px!important',
                    // },
                },
            },

            '& .payment-transaction-history-container': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                paddingLeft: '32px',
                paddingRight: '37px',
                paddingTop: '18px',
                paddingBottom: '27px',
                maxHeight: '400px',

                '& .payment-transaction-history-text': {
                    fontFamily: theme.typography.body1.fontFamily,
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: theme.typography.body1.fontSize,
                    lineHeight: '24px',
                    color: theme.palette.primary.heather,
                },
            },

            '& .payment-summary-container': {
                maxWidth: '1016px',

                padding: '0px',
                margin: '0px auto',
                paddingBottom: '50px',

                '& .payment-summary': {
                    width: '100%',
                    maxWidth: '654px',
                    margin: '0px auto',

                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',

                    '& .payment-summary-header': {
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0px',
                        // marginLeft: '176px',

                        '& .payment-summary-keys': {
                            maxWidth: '600px',
                            borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            paddingBottom: '12px',

                            '& div': {
                                width: '93px',
                                textAlign: 'center',
                            },
                        },

                        '& .Payment-summary__headerIcon': {
                            flex: '1',
                        },

                        '& .payment-date, & .payment-type, & .payment-amount, & .payment-balance': {
                            fontFamily: theme.typography.subtitle1.fontFamily,
                            fontStyle: 'normal',
                            // fontWeight: 'bold',
                            fontSize: theme.typography.body1.fontSize,
                            lineHeight: '24px',
                        },
                    },

                    '& .bar-container': {
                        display: 'none',
                        width: '670px',
                        height: '0px',
                        border: `1px solid ${theme.palette.primary.borderColor}`,
                        marginLeft: '15rem',
                        marginBottom: '6px',
                    },

                    '& .payment-summary-accordion': {
                        // display: 'block',
                        // padding: '0px 32px',
                        // maxWidth: '952px',
                        // margin: 'auto',
                        maxWidth: '654px',
                        width: '100%',

                        '& .payment-summary-card': {
                            // width: '80%',
                            // marginLeft: '167px',
                            border: '0',
                            borderRadius: '0',
                            background: theme.palette.primary.white,
                            minHeight: '55px',
                            marginTop: '0px',
                            // marginBottom: '1px',
                            boxShadow: `0px 1px 0px ${theme.palette.primary.white}`,

                            '&.MuiAccordion-root:before': {
                                backgroundColor: 'transparent',
                            },
                            // Accordian Header
                            '& .payment-summary-card__header': {
                                fontFamily: theme.typography.body1.fontFamily,
                                cursor: 'pointer',
                                minHeight: '55px',
                                color: theme.palette.primary.heather,
                                position: 'relative',
                                // marginRight: '16rem',
                                padding: '0px',
                                justifyContent: 'space-between',

                                //Accordian header Content
                                '& .payment-summary-card__header-content': {
                                    paddingBottom: '10px',
                                    paddingTop: '10px',
                                    fontFamily: theme.typography.body3Medium.fontFamily,
                                    fontStyle: 'normal',
                                    // fontWeight: 600,
                                    fontSize: theme.typography.body3Medium.fontSize,
                                    lineHeight: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: theme.palette.primary.heather,
                                    maxWidth: '600px',
                                    margin: '0px',
                                    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,

                                    '& .payment-summary-data-container': {
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '0px',

                                        '& .summary-amount': {
                                            '& .invoice-amount': {
                                                color: theme.palette.primary.error,
                                            },
                                        },

                                        '& .summary-balance': {
                                            '& .invoice-balance': {
                                                color: theme.palette.primary.error,
                                            },
                                        },

                                        '& div': {
                                            textAlign: 'center',
                                        },
                                    },

                                    // paddingLeft: "10px",
                                    // paddingRight: "90px",
                                    // paddingBottom: "10px",
                                },

                                '& .payment-summary-card__header-expandIcon': {
                                    // position: 'absolute',
                                    padding: 0,
                                    margin: 0,
                                    bottom: '8px',
                                    right: '5px',
                                },

                                '& .payment-summary-expand-icon': {
                                    height: '21px',
                                    width: '21px',
                                    color: theme.palette.primary.sunset,
                                },
                            },
                            //Accordian Body
                            '& .payment-summary-card__body': {
                                // padding: '0px 10px 17px 10px',
                                paddingLeft: '9px',
                                padding: '0px',

                                '& .payment-summary-card__menu': {
                                    padding: 0,
                                    right: '9px',
                                    background: '#F3F5F9',
                                    width: '93.2%',

                                    '& .payment-summary-list': {
                                        fontFamily: theme.typography.body1.fontFamily,
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: theme.typography.subtitle2.fontSize,
                                        lineHeight: '22px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: theme.palette.primary.heather,

                                        '& .bold': {
                                            fontWeight: '600',
                                        },

                                        '& .summary-data-container': {
                                            width: '101%',
                                            height: '32px',
                                            display: 'flex',
                                            justifyContent: 'space-around',
                                            alignItems: 'center',
                                            marginLeft: '0rem',

                                            '& p': {
                                                margin: '0px',
                                            },

                                            '& .summary-amount': {
                                                '& .amount': {
                                                    color: theme.palette.primary.error,
                                                },
                                            },

                                            '& .summary-balance': {
                                                paddingLeft: '18px',

                                                '& .balance': {
                                                    color: theme.palette.primary.error,
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },

            '& .see-more-payment': {
                paddingTop: '20px',
                paddingBottom: '52.35px',

                '& .more-payment-button, & .less-payment-button': {
                    fontFamily: theme.typography.body3Medium.fontFamily,
                    fontStyle: 'normal',
                    // fontWeight: 700,
                    fontSize: theme.typography.body3Medium.fontSize,
                    lineHeight: '24px',
                    textAlign: 'center',
                    color: theme.palette.primary.sunset,

                    display: 'flex',
                    alignItems: 'center',

                    margin: 'auto',

                    cursor: 'pointer',

                    '&:hover': {
                        color: theme.palette.primary.sunset,
                    },
                },
            },
        },

        '& .summary-date, & .summary-type, & .summary-amount, & .summary-balance': {
            width: '122px',
        },

        // '& .summary-date': {
        //     paddingRight: '11px',
        // },

        // '& .summary-type': {
        //     paddingRight: '30px',
        // },

        // '& .summary-amount': {
        //     paddingRight: '30px',
        // },

        '& .summary-balance': {
            paddingLeft: '20px',
        },

        '& .date, & .type, & .amount, & .balance, & .invoice-amount, & .invoice-balance': {
            fontFamily: theme.typography.body1.fontFamily,
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: '16px',
        },
        '& .negative': {
            fontFamily: theme.typography.body1.fontFamily,
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: theme.typography.body1.fontSize,
            lineHeight: '16px',
            color: `${theme.palette.primary.error} !important`,
        },
    },
    headerBackArrow: {
        height: '16px',
        width: '16px',
        display: 'flex',
        color: theme.palette.primary.sunset,
        cursor: 'pointer',
        paddingBottom: '21px',
        marginLeft: '-5px',
        // paddingTop: '10px',
        '@media(max-width: 599px)': {
            height: '13.33px',
            width: '13.33px',
            paddingBottom: '18px',
            marginLeft: '-1px',
        },
    },
    inActiveUserContainer: {
        height: '400px',
        marginTop: '24px',
        marginBottom: '12px',
        [theme.breakpoints.down('xs')]: {
            marginBottom: 'unset',
            marginTop: '50px',
        },
    },
    detailsHeaderText: {
        display: 'flex',
        marginTop: '21px',
        minHeight: '45px',
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontStyle: 'normal',
        // fontWeight: 700,
        fontSize: theme.typography.h4.fontSize,
        lineHeight: '26px',
        color: theme.palette.primary.heather,
        marginRight: '32px',
        // borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
        position: 'relative',

        '@media(max-width: 599px)': {
            marginTop: '18.58px',
            // borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
            minHeight: '44px',
            fontSize: theme.typography.h4.fontSize,
            marginLeft: '4px',
        },

        '& .changeEmail-header-line': {
            position: 'absolute',
            left: '0%',
            right: '0%',
            bottom: '3px',
            border: `1px solid ${theme.palette.primary.borderColor}`,
            borderTopWidth: '0px',

            '@media(max-width: 599px)': {
                bottom: '0px',
            },
        },
    },
    bottomLine: {
        borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    },

    DisplayNone: {
        display: 'none',
    },
}));
